module.exports = __webpack_public_path__ + "static/media/monthlyPLAnalaysis_ja_light.2b109260.png";